import { RouteName } from '@mews-commander/enums';
import { MultipleAccountFileAddParameters, MultipleAccountFileUpdateParameters } from '@mews-commander/data-access';
import { Identifiable } from '@mews/std';
import { AsyncAction, CommanderThunkAction, WithOwnerId } from '@mews-commander/types';
import { createFetchAction, openInBrowserTab } from '@mews-commander/utils';
import { FILE_ADD, FILE_DELETE, FILE_UPDATE, getFile } from '../ducks/files';

interface DownloadFileProps extends Identifiable {
    isCompanyFile?: boolean;
}

export const addFile =
    ({ files, ownerId }: MultipleAccountFileAddParameters & WithOwnerId): CommanderThunkAction<AsyncAction> =>
    async (dispatch, getState, { repositories }) => {
        const promise = repositories.accountFiles.add({ files }).then((response) => {
            const file = response.files?.[0];

            return {
                ownerId,
                ...file,
            };
        });
        return dispatch(createFetchAction(FILE_ADD, promise));
    };

export const updateFile =
    ({ accountFileUpdates }: MultipleAccountFileUpdateParameters): CommanderThunkAction<AsyncAction> =>
    async (dispatch, getState, { repositories }) => {
        const promise = repositories.accountFiles.update({ accountFileUpdates }).then((response) => {
            const file = response.files?.[0];

            return {
                ...file,
            };
        });
        return dispatch(createFetchAction(FILE_UPDATE, promise));
    };

export const deleteFile =
    ({ id }: Identifiable): CommanderThunkAction<AsyncAction> =>
    async (dispatch, getState, { repositories }) => {
        const file = getFile(getState(), { id });
        const promise = repositories.accountFiles.delete({ accountFileIds: [id] }).then(() => file);
        return dispatch(createFetchAction(FILE_DELETE, promise));
    };

export const downloadFile =
    ({ id, isCompanyFile = false }: DownloadFileProps): CommanderThunkAction =>
    (_dispatch, _getState, { resolveRoute }) => {
        const url = isCompanyFile
            ? resolveRoute(RouteName.CompanyDownloadFile, { query: { id, Layout: 'Empty' } })
            : resolveRoute(RouteName.CustomerDownloadFile, { query: { id, Layout: 'Empty' } });
        openInBrowserTab(url);
    };
